import { Popup } from '@smartplatform/ui';
import { observable } from 'mobx';
import { observer } from 'mobx-react';
import moment from 'moment';
import React from 'react';
import './style.scss';
@observer
export default class Report extends React.Component {

	@observable record = null;

	constructor(props) {
		super(props);
		this.record = this.props.selectedRecord;
	}

	renderOwner = record => {
		const owner = record.owner;
		if (!owner) {
			return;
		}
		const fio = [owner.lastName, owner.firstName, owner.middleName].join(' ').trim();
		return fio || owner.username;
	};

	render() {
		const dateRegExp = new RegExp('\\d{4}-\\d{2}-\\d{2}T')
		return <Popup onClose={this.props.onClose} className='popup'>
			<div className='report'>
			<div className='title'>Модель : {this.record.model}</div>
			<div className='action'>Действие : {this.record.action}</div>
			<div className='action'>Пользователь : {this.renderOwner(this.record)}</div>
			{!this.record.instance
				? <div>Нет данных</div>
				:
				<div className='model-values'>
					{Object.entries(this.record.instance)
						.map((item, index) => dateRegExp.test(String(item[1]))
							?
							<p key={index}>
								<strong>{item[0]}</strong>: {item[1] && moment(item[1]).format('YYYY.MM.DD HH:mm') || 'null'}
							</p>
							: <p key={index}>
								<strong>{item[0]}</strong>: {String(item[1])}
							</p>
						)}
				</div>
			}
			</div>
		</Popup>
	}
}
